module.exports = __webpack_public_path__ + "img/bannerBlue.85f580e1.jpg";